import styled from 'styled-components';

export const LazyContainer = styled.div`
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
  position: absolute;
  top: 0;
  left: 0;
  z-index: -10;

  img {
    object-fit: cover;
  }
`;
